import { render, staticRenderFns } from "./oaTaskTemplate.vue?vue&type=template&id=3468c228&scoped=true&"
import script from "./oaTaskTemplate.vue?vue&type=script&lang=js&"
export * from "./oaTaskTemplate.vue?vue&type=script&lang=js&"
import style0 from "./oaTaskTemplate.vue?vue&type=style&index=0&id=3468c228&lang=scss&scoped=true&"
import style1 from "./oaTaskTemplate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3468c228",
  null
  
)

export default component.exports